import React from 'react';
import './pageCollectionHeader.scss';

interface PageCollectionHeaderProps {
  eyebrow: string;
  title: React.ReactNode;
  subtitle: string;
  imageUrl?: string;
  imageAlt?: string;
}

const PageCollectionHeader = ({
  eyebrow,
  title,
  subtitle,
  imageUrl,
  imageAlt,
}: PageCollectionHeaderProps) => (
  <div className="page-collection-header">
    <div className="page-collection-header__copy">
      <p className="page-collection-header__eyebrow">{eyebrow}</p>
      <div className="page-collection-header__title-row">
        {imageUrl ? (
          <img
            src={imageUrl}
            alt={imageAlt ?? ''}
            className="page-collection-header__icon"
          />
        ) : null}
        <h2 className="page-collection-header__title">{title}</h2>
      </div>
      <p className="page-collection-header__subtitle">{subtitle}</p>
    </div>
  </div>
);

export default PageCollectionHeader;
